import { render, staticRenderFns } from "./BestsellerCard.vue?vue&type=template&id=54718644&scoped=true&"
import script from "./BestsellerCard.vue?vue&type=script&lang=js&"
export * from "./BestsellerCard.vue?vue&type=script&lang=js&"
import style0 from "./BestsellerCard.vue?vue&type=style&index=0&id=54718644&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54718644",
  null
  
)

export default component.exports